import { render, staticRenderFns } from "./User_rights.vue?vue&type=template&id=3fb00027&"
import script from "./User_rights.vue?vue&type=script&lang=js&"
export * from "./User_rights.vue?vue&type=script&lang=js&"
import style0 from "./User_rights.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports